import React from 'react'
import { Analytics } from '@deal/web-tracking'

export interface AnalyticsProviderProps {
  client: Analytics
}

// Context
const AnalyticsContext = React.createContext<Analytics | undefined>(undefined)

// Consumer
const AnalyticsConsumer = AnalyticsContext.Consumer

// Provider
const AnalyticsProvider: React.SFC<AnalyticsProviderProps> = ({ client, children }) => {
  return <AnalyticsContext.Provider value={client}>{children}</AnalyticsContext.Provider>
}

export { withAnalytics, WithAnalyticsProps } from './withAnalytics'
export { AnalyticsProvider, AnalyticsConsumer, AnalyticsContext }
